import React, { SVGProps, Suspense } from 'react'
import { getPixelString } from '@commutifi-fe/utils'
import { Skeleton } from '../Skeleton'
import './styles.scss'

export function LazySvg({ src, height, width, alt, className, children }: LazySvgProps) {
  return (
    <div
      style={{
        height: getPixelString(height),
        width: getPixelString(width)
      }}
      className="app-lazy-svg"
    >
      <Suspense fallback={<Skeleton.Image className="app-lazy-svg-img" style={{ height, width }} active />}>
        {src ? (
          <img
            loading="lazy"
            src={src}
            height={`${height}px`}
            width={typeof width === 'number' ? width : undefined}
            alt={alt}
            className={className}
          />
        ) : (
          children
        )}
      </Suspense>
    </div>
  )
}

export interface LazySvgProps extends SVGProps<SVGSVGElement> {
  src?: string
  height: number
  width: number | string
  alt: string
  className?: string
  children?: React.ReactNode
}
